export const PORTAL = {
    LOGIN: `/login`,
    FORGOT_PASSWORD: `/forgot-password`,
    DASHBOARD: `/`
}
